import { scheduleRhythm } from "@/mocks/content";

export default function ScheduleSection() {
  return (
    <section id="schedule" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-secondary-700">
              <i className="ri-calendar-check-line"></i>
              上线节奏
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              了解更新节奏，追剧不再干等
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              韩剧的更新并非随机，而是由档期、制作模式和集数安排共同决定。理解这几层逻辑后，
              你就能大致判断什么时候会有新内容，也能选择更适合自己的追剧方式。
            </p>
          </div>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2">
          {scheduleRhythm.map((item, index) => (
            <li
              key={item.title}
              className="relative flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <div className="flex flex-col items-center">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                  {index + 1}
                </span>
                {index < scheduleRhythm.length - 2 && (
                  <span className="mt-2 hidden w-px flex-1 bg-background-300 md:block"></span>
                )}
              </div>
              <div>
                <span className="inline-block rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900">
                  {item.phase}
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-700">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-8 flex flex-col gap-3 rounded-lg border border-background-200 bg-secondary-50 p-5 md:flex-row md:items-center md:justify-between md:p-6">
          <p className="text-sm leading-6 text-foreground-800">
            <strong className="font-semibold text-foreground-950">小提示：</strong>
            档期与更新安排可能随播出平台与制作进度调整，最终以实际播出的官方信息为准。
          </p>
          <a
            href="#faq"
            className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
          >
            查看常见问题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}